import detectOperatorPrefix from './detectOperatorPrefix.js';

const buildFilteringSettingsFromCandidate = (candidate) => {
  if (!candidate) {
    return null;
  }

  const allRawOperatorTokens = [...candidate.analysis.rawOperatorTokensBySlug.values()].flatMap((tokens) => [...tokens]);
  const operatorPrefix = detectOperatorPrefix(allRawOperatorTokens);

  const getLogicalToken = (logicalKey, fallbackValue) => {
    return [...candidate.analysis.logicalTokens[logicalKey]][0] || fallbackValue;
  };

  return {
    andToken: getLogicalToken('and', 'and'),
    argName: candidate.argument.name,
    notToken: getLogicalToken('not', 'not'),
    operatorPrefix,
    operatorStyle: candidate.analysis.postfixFieldCount > candidate.analysis.nestedFieldCount ? 'postfix' : 'nested',
    orToken: getLogicalToken('or', 'or')
  };
};

export default buildFilteringSettingsFromCandidate;
